import React, { Component } from "react";

export class NominationTableHead extends Component {
  render() {
    return (
      <React.Fragment>
        <tr className="super_admin_all_users_table_head">
          {/* <th style={{ width: "10%" }} className="f12-500">
            ID
          </th> */}
          <th
            style={{ width: "17%", fontWeight: "normal" }}
            className="f12-400"
          >
            Restaurant Name
          </th>
          {/* <th style={{ width: "13%" }} className="f12-500">
            Phone Number
          </th> */}
          <th
            style={{ width: "30%", fontWeight: "normal" }}
            className="f12-400"
          >
            Address
          </th>
          {/* <th style={{ width: "15%" }} className="f12-500">
            Restaurant type
          </th> */}
          <th
            style={{ width: "10%", fontWeight: "normal" }}
            className="f12-400"
          >
            City
          </th>
          <th
            style={{ width: "12%", fontWeight: "normal" }}
            className="f12-400"
          >
            Area /<br />
            Zip Code
          </th>
          <th
            style={{ width: "15%", fontWeight: "normal" }}
            className="f12-400"
          >
            Total
            <br />
            Nominations
          </th>
          <th style={{ width: "8%", fontWeight: "normal" }} className="f12-400">
            Sign Up
            <br />
            Yet?
          </th>
          <th
            style={{ width: "8%", fontWeight: "normal" }}
            className="f12-400"
          ></th>
        </tr>
      </React.Fragment>
    );
  }
}

export default NominationTableHead;
